import RootState from 'store/state';
import { useSelector } from 'react-redux';

function useChat() {

    const chat = useSelector<RootState, RootState["chat"]>(
        ({ chat }) => chat
    )

    return chat
}

export default useChat;